/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContactsReportRequestDto } from '../models';
// @ts-ignore
import type { ReportJobDto } from '../models';
/**
 * RestReportsApi - axios parameter creator
 */
export const RestReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download generated report file
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReportFile: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('downloadReportFile', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}/file`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request contacts report generation (async)
         * @param {ContactsReportRequestDto} contactsReportRequestDto Contacts report request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateContactsReport: async (contactsReportRequestDto: ContactsReportRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactsReportRequestDto' is not null or undefined
            assertParamExists('generateContactsReport', 'contactsReportRequestDto', contactsReportRequestDto)
            const localVarPath = `/api/reports/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactsReportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get report job status
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportStatus: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReportStatus', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestReportsApi - functional programming interface
 */
export const RestReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download generated report file
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadReportFile(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadReportFile(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestReportsApi.downloadReportFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request contacts report generation (async)
         * @param {ContactsReportRequestDto} contactsReportRequestDto Contacts report request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateContactsReport(contactsReportRequestDto: ContactsReportRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportJobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateContactsReport(contactsReportRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestReportsApi.generateContactsReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get report job status
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportStatus(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportJobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportStatus(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestReportsApi.getReportStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestReportsApi - factory interface
 */
export const RestReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Download generated report file
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReportFile(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadReportFile(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request contacts report generation (async)
         * @param {ContactsReportRequestDto} contactsReportRequestDto Contacts report request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateContactsReport(contactsReportRequestDto: ContactsReportRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ReportJobDto> {
            return localVarFp.generateContactsReport(contactsReportRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get report job status
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportStatus(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportJobDto> {
            return localVarFp.getReportStatus(reportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestReportsApi - interface
 */
export interface RestReportsApiInterface {
    /**
     * 
     * @summary Download generated report file
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadReportFile(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Request contacts report generation (async)
     * @param {ContactsReportRequestDto} contactsReportRequestDto Contacts report request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateContactsReport(contactsReportRequestDto: ContactsReportRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ReportJobDto>;

    /**
     * 
     * @summary Get report job status
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportStatus(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportJobDto>;

}

/**
 * RestReportsApi - object-oriented interface
 */
export class RestReportsApi extends BaseAPI implements RestReportsApiInterface {
    /**
     * 
     * @summary Download generated report file
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadReportFile(reportId: string, options?: RawAxiosRequestConfig) {
        return RestReportsApiFp(this.configuration).downloadReportFile(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request contacts report generation (async)
     * @param {ContactsReportRequestDto} contactsReportRequestDto Contacts report request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateContactsReport(contactsReportRequestDto: ContactsReportRequestDto, options?: RawAxiosRequestConfig) {
        return RestReportsApiFp(this.configuration).generateContactsReport(contactsReportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get report job status
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportStatus(reportId: string, options?: RawAxiosRequestConfig) {
        return RestReportsApiFp(this.configuration).getReportStatus(reportId, options).then((request) => request(this.axios, this.basePath));
    }
}

